import React, { useState, useEffect, useCallback } from 'react';
import { isDesktop } from 'react-device-detect';

import {
  useGameCastProgressBar,
  useGameCastSteps,
} from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/hooks';
import LoadingProgressTutorial from '@core/dashboard/components/LoadingProgressTutorial';
import AppLoader from '@core/dashboard/components/AppLoader';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useLandscapeDetection } from '@hooks/orientation';
import { useEventContext } from '@providers/EventProvider';
import { useMytaverse } from '@providers/MytaverseProvider';
import { AnalyticsType } from '@interfaces/analytics';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { CurrentScreenEnum } from '@providers/MytaverseProvider/interfaces';
import { getTeleportToHubDelay } from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/helper';
import { isSinglePlayerEvent } from '@helpers/events';

const GameCastLoader = () => {
  const [isReadyToEnter, setIsReadyToEnter] = useState(false);
  const [showTeleportButton, setShowTeleportButton] = useState(false);

  const { setIsEventRun } = useEventContext();
  const isLandscape = useLandscapeDetection();
  const { currentEvent, trackEventAnalytics } = useMytaverseEvent();
  const {
    isDebugMode,
    sendJSONMessageToWebSocket,
    pageClicked,
    setCurrentScreen,
  } = useMytaverse();

  const {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  } = useGameCastSteps();

  const progressValue = useGameCastProgressBar({
    isStreamLoaded: forthStepLoading,
    isUeLoaded: forthStepCompleted,
  });

  const handleTeleportToWorld = useCallback(async () => {
    setIsEventRun(true);

    trackEventAnalytics(AnalyticsType.TeleportToWorldClick);

    sendJSONMessageToWebSocket({
      action: WebsocketAction.MytaverseAction,
      tag: 'MytaEvent.Action.Player.Joined',
      data: '',
    });
  }, [trackEventAnalytics]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;

    const delay = getTeleportToHubDelay(isSinglePlayerEvent(currentEvent));

    if (forthStepCompleted && currentEvent && !isDebugMode) {
      timeoutId = setTimeout(() => {
        if (pageClicked) {
          setIsReadyToEnter(true);
          setCurrentScreen(CurrentScreenEnum.WORLD);
        } else {
          setShowTeleportButton(true);
        }
      }, delay);
    }

    if (isDebugMode) {
      setIsReadyToEnter(true);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [forthStepCompleted, currentEvent, isDebugMode, setCurrentScreen]);

  useEffect(() => {
    if (isReadyToEnter) {
      handleTeleportToWorld();
    }
  }, [isReadyToEnter, handleTeleportToWorld]);

  useEffect(() => {
    if (secondStepCompleted) {
      setCurrentScreen(CurrentScreenEnum.LOADING_STREAM);
    }
  }, [secondStepCompleted, setCurrentScreen]);

  useEffect(() => {
    if (thirdStepCompleted) {
      setCurrentScreen(CurrentScreenEnum.LOADING_UE);
    }
  }, [thirdStepCompleted, setCurrentScreen]);

  const handleTeleportButtonClick = useCallback(() => {
    setShowTeleportButton(false);
    setIsReadyToEnter(true);
    setCurrentScreen(CurrentScreenEnum.WORLD);
  }, [setCurrentScreen]);

  return (
    <AppLoader
      isLandscape={isLandscape && !isDesktop}
      progressValue={progressValue}
      showTeleportButton={showTeleportButton}
      handleTeleportButtonClick={handleTeleportButtonClick}
    >
      {/* <LoadingProgressTutorial
        secondStepLoading={secondStepLoading}
        secondStepCompleted={secondStepCompleted}
        thirdStepLoading={thirdStepLoading}
        thirdStepCompleted={thirdStepCompleted}
        forthStepLoading={forthStepLoading}
        forthStepCompleted={forthStepCompleted}
        showTeleportButton={showTeleportButton}
        handleTeleportButtonClick={handleTeleportButtonClick}
      /> */}
    </AppLoader>
  );
};

export default GameCastLoader;
